/* global google, MarkerClusterer */
/* eslint no-undef: "error" */
import theme from '../theme.json';
import rlxMapStyles from './rlxMapStyles';
import { handleGoogleMapsConsentNotice } from '../../components/cmpListener';

function initMap($map) {
    if ($map.data('map-is-fully-initialised') === true) {
        return;
    }
    $map.data('map-is-fully-initialised', true);

    const $storeDetails = $('.js_store-details');
    const $storeDetailsClose = $('.js_details-close');
    const allMarkers = [];
    const openClass = 'is-open';

    const storeIcon = {
        url: '/themes/Frontend/Wempe/frontend/_public/src/img/rolex-v7/icons/rlx-v7-store.svg',
        scaledSize: new google.maps.Size(36, 42),
        size: new google.maps.Size(36, 42),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 21),
    };
    const storeSelectedIcon = {
        url: '/themes/Frontend/Wempe/frontend/_public/src/img/rolex-v7/icons/rlx-v7-store-selected.svg',
        scaledSize: new google.maps.Size(36, 42),
        size: new google.maps.Size(36, 42),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 21),
    };

    const locatorMap = new google.maps.Map($map[0], {
        zoom: 10,
        styles: theme,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: true,
        cameraControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
        },
    });

    locatorMap.setOptions({
        styles: rlxMapStyles(),
    });

    const deselectAllMarkers = () => {
        allMarkers.forEach((marker) => {
            marker.selected = false; // eslint-disable-line no-param-reassign
            marker.setIcon(storeIcon);
        });
    };

    const showStoreDetails = (details) => {
        const $storeName = $storeDetails.find('.js_replace');
        const $storeNameAttribute = $storeDetails.find('[data-store-name]');
        const $storeAddress = $storeDetails.find('.js_address');
        const $storeShortAddress = $storeDetails.find('.js_short-adress');
        const $storePhone = $storeDetails.find('.js_phone');
        const $detailLink = $storeDetails.find('.js_detail-link');

        $storeNameAttribute.attr('data-store-name', details.name); $storeName.html(details.name);
        $storeAddress.html(details.address); $storeShortAddress.html(details.shortAddress);
        $storePhone.find('.rlx-v7-icon-button__content').text(details.phone); $storePhone.attr('href', `tel:${details.phone}`);

        // Check if the store details overlay OR the clicked store item has the CPO class
        let finalLink = details.link || '';
        const isCpo = $storeDetails.hasClass('js--is-cpo') ||
                    $storeDetails.find('.js--is-cpo').length > 0 ||
                    $(`[data-store-id=${details.storeId}]`).hasClass('js--is-cpo');

        if (isCpo && finalLink) {
            finalLink = finalLink.replace('?rlx=true', '?rlx-cpo=true');
        }

        $detailLink.attr('href', finalLink);

        $storeDetails.addClass(openClass);

        $storeDetailsClose.on('click', () => {
            $storeDetails.removeClass(openClass);
            deselectAllMarkers();
        });
    };

    const placeStoresOnMap = (stores, map) => {
        const bounds = new google.maps.LatLngBounds();
        let activeFilter = null;
        const uniqueStoreIds = [];

        stores.forEach((store) => {
            if (uniqueStoreIds.includes(store.storeId)) {
                return;
            }
            uniqueStoreIds.push(store.storeId);

            const position = { lat: store.lat, lng: store.lng };
            bounds.extend(position);

            const marker = new google.maps.Marker({
                position,
                storeDetails: store,
                icon: storeIcon,
                selected: false,
            });

            allMarkers.push(marker);

            marker.addListener('click', function handleClick() {
                const storeDetails = this.storeDetails;

                deselectAllMarkers();

                marker.selected = true;
                marker.setIcon(storeSelectedIcon);

                showStoreDetails(storeDetails);
            });

            marker.addListener('mouseover', () => {
                if (!marker.selected) {
                    marker.setIcon(storeSelectedIcon);
                }
            });

            marker.addListener('mouseout', () => {
                if (!marker.selected) {
                    marker.setIcon(storeIcon);
                }
            });
        });

        // ==========================================================================
        // DYNAMISCHER START-ZOOM JE NACH SHOP-DEUTSCHLAND / INTERNATIONAL
        // ==========================================================================
        const currentShop = document.body.getAttribute('data-current-shop') || '';

        if (currentShop.toLowerCase() === 'de-de') {
            // Wenn es der deutsche Shop ist: Zentriere auf Deutschland (Mitte) mit Zoom 6
            map.setCenter({ lat: 51.165691, lng: 10.451526 });
            map.setZoom(6);
        } else {
            // Für internationale Shops: Alle Marker (inkl. New York) auf einmal anzeigen
            map.fitBounds(bounds);
        }

        // Initiiere den Clusterer komplett ohne automatische Zoom-Logik, da wir ihn manuell steuern
        // const markerCluster = new MarkerClusterer(map, [], {
        //     cssClass: 'rlx-v7-map-cluster',
        // });

        const markerCluster = new MarkerClusterer(map, [], {
            cssClass: 'rlx-v7-map-cluster',
            gridSize: 20, // Ein gesunder Mittelweg für Städte wie Berlin
            minimumClusterSize: 2,
            maxZoom: 12, // Bis zu diesem Zoomlevel darf geclustert werden
        });

        google.maps.event.addListener(markerCluster, 'clusterclick', (cluster) => {
            $storeDetailsClose.click();

            // 1. Hole die Map und die Marker des geklickten Clusters
            const mapClustered = markerCluster.getMap();

            // 2. Erstelle temporäre Bounds für die Marker in diesem Cluster
            const clusterBounds = new google.maps.LatLngBounds();
            const markers = cluster.getMarkers();
            markers.forEach(marker => clusterBounds.extend(marker.getPosition()));

            // 3. Clusterer sofort leeren, damit die Icons beim Zoomen optisch verschwinden
            markerCluster.clearMarkers();

            // 4. Sanft zum neuen Bereich zoomen
            mapClustered.fitBounds(clusterBounds);
        });

        // ==========================================================================
        // MANUELLE CLUSTER-KONTROLLE (Kombiniertes Limit gegen "Sticky" Icons)
        // ==========================================================================
        const applyFilters = () => {
            const currentBounds = locatorMap.getBounds();
            if (!currentBounds) return;

            const currentZoom = locatorMap.getZoom(); // Aktuellen Zoom holen
            $map.attr('data-current-zoom', currentZoom);
            const $listItems = $('.js-store-item');
            $listItems.hide();

            // Radikal aufräumen
            markerCluster.clearMarkers();

            const clusterMarkers = [];

            allMarkers.forEach((marker) => {
                const details = marker.storeDetails;
                const $storeDOM = $(`#store-${details.storeId}`);

                const storeLatLng = new google.maps.LatLng(details.lat, details.lng);
                const isInBounds = currentBounds.contains(storeLatLng);

                let hasService = true;
                if (activeFilter) {
                    hasService = $storeDOM.data(`service-${activeFilter}`) === true;
                }

                if (isInBounds && hasService) {
                    $storeDOM.show();

                    // WENN DER USER NÄHER ALS ZOOM 12 DRIN IST (z.B. Stadtansicht Berlin):
                    // Umgehen wir den Clusterer komplett und zwingen Google,
                    // die Nadel direkt zu zeichnen.
                    if (currentZoom >= 12) {
                        marker.setMap(map);
                    } else {
                        // Wenn wir weiter weg sind, übergeben wir den Marker zum Clustern
                        clusterMarkers.push(marker);
                    }
                } else {
                    if (marker.selected) {
                        $storeDetailsClose.click();
                    }
                    marker.setMap(null);
                }
            });

            // Dem Clusterer nur die Marker geben, die auch wirklich geclustert werden sollen
            setTimeout(() => {
                if (clusterMarkers.length > 0) {
                    markerCluster.addMarkers(clusterMarkers, true);
                }
                markerCluster.repaint();
            }, 0);

            if (currentZoom >= 12) {
                markerCluster.clearMarkers();
                markerCluster.repaint();
            } else {
                // Dem Clusterer nur die Marker geben, die auch wirklich geclustert werden sollen
                setTimeout(() => {
                    if (clusterMarkers.length > 0) {
                        markerCluster.addMarkers(clusterMarkers, true);
                    }
                    markerCluster.repaint();
                }, 0);
            }
        };

        google.maps.event.addListener(locatorMap, 'idle', () => {
            applyFilters();
        });

        $(document).off('click', '.js-store-list-filter-btn').on('click', '.js-store-list-filter-btn', function handleFilterClick(e) {
            e.preventDefault();
            const $clickedBtn = $(this);
            const filterType = $clickedBtn.data('filter');
            const activeClass = 'is-active';

            if ($clickedBtn.hasClass(activeClass)) {
                $clickedBtn.removeClass(activeClass);
                activeFilter = null;
            } else {
                $('.js-store-list-filter-btn').removeClass(activeClass);
                $clickedBtn.addClass(activeClass);
                activeFilter = filterType;
            }

            applyFilters();
        });

        $(document).off('click', '.js-store-item').on('click', '.js-store-item', function handleSidebarClick(e) {
            if ($(e.target).is('a') || $(e.target).closest('a').length) return;

            const targetStoreId = parseInt($(this).data('store-id'), 10);
            const foundMarker = allMarkers.find(marker =>
                marker.storeDetails.storeId === targetStoreId,
            );

            if (foundMarker) {
                locatorMap.setZoom(14);
                locatorMap.panTo(foundMarker.getPosition());
                google.maps.event.trigger(foundMarker, 'click');
            }
        });

        $(document).off('click', '.js-store-list-mobile-toggle-btn').on('click', '.js-store-list-mobile-toggle-btn', function handleMobileToggle(e) {
            e.preventDefault();
            const $btn = $(this);
            const $itemsContainer = $('.rlx-v7-locator__store-list__items');
            const collapsedClass = 'is-collapsed';

            const isCollapsed = $btn.hasClass(collapsedClass);

            if (isCollapsed) {
                $btn.removeClass(collapsedClass).attr('aria-expanded', 'true');
                $itemsContainer.removeClass(collapsedClass);
            } else {
                $btn.addClass(collapsedClass).attr('aria-expanded', 'false');
                $itemsContainer.addClass(collapsedClass);
            }
        });
    };

    $.get($map.data('store-load-url'), (retailers) => {
        placeStoresOnMap(retailers, locatorMap);
    });
}

export default function rlxLocatorMap() {
    const isLoadedAttr = 'data-gmaps-is-loaded';
    const isInitialisedAttr = 'data-is-initialised';

    let $map = $('.js_locator-map').not(`[${isInitialisedAttr}]`);
    const tryInit = () => {
        $map = $('.js_locator-map').not(`[${isInitialisedAttr}]`);

        if ($map.length && typeof window.google !== 'undefined' && document.body.hasAttribute(isLoadedAttr)) {
            $map.attr(isInitialisedAttr, true);
            handleGoogleMapsConsentNotice();
            initMap($map);
            return true; // Erfolgreich initialisiert
        }
        return false;
    };
    if (tryInit()) return;

    const observer = new MutationObserver((mutations) => {
        let shouldCheck = false;

        mutations.forEach((mutation) => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                shouldCheck = true;
            }
            if (mutation.type === 'attributes' && mutation.attributeName === isLoadedAttr) {
                shouldCheck = true;
            }
        });

        if (shouldCheck) {
            if (tryInit()) {
                observer.disconnect();
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [isLoadedAttr],
    });
}
